import { render } from "./AssinaturaEncerramento.vue?vue&type=template&id=5cb69364&scoped=true"
import script from "./AssinaturaEncerramento.vue?vue&type=script&lang=js"
export * from "./AssinaturaEncerramento.vue?vue&type=script&lang=js"

import "./AssinaturaEncerramento.vue?vue&type=style&index=0&id=5cb69364&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb69364"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QSelect,QTooltip});
